import React, { useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { DevisContext } from '../context/DevisContext';
import './Navbar.css';

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);
  const { unreadCount } = useContext(DevisContext);
  const history = useHistory();

  const handleLogout = () => {
    logout();
    history.push('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          L'EXPERT RÉNOVATION
        </Link>
        <div className="navbar-menu">
          <Link to="/" className="navbar-link">Tableau de bord</Link>
          <Link to="/devis" className="navbar-link">
            Devis
            {unreadCount > 0 && (
              <span className="navbar-badge">{unreadCount}</span>
            )}
          </Link>
          {user?.is_admin && (
            <Link to="/users" className="navbar-link">Utilisateurs</Link>
          )}
          <Link to="/profile" className="navbar-link">Profil</Link>
          {user && (
            <div className="navbar-user">
              <span className="navbar-user-icon">👤</span>
              <span className="navbar-user-name">{user.username}</span>
            </div>
          )}
          <button onClick={handleLogout} className="navbar-logout">
            Déconnexion
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

